<template>
  <div class="research-b">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>

    <!-- 输入框 -->
    <div class="box-input">
      <inputBox @query="queryList" v-model:inputValue="mydata.form.search"></inputBox>
    </div>
    <!-- 内容 -->
    <researchCard
      :path="mydata.path"
      class="research"
      v-for="(item, index) in mydata.articleListArr"
      :key="index"
      :info="item"
    ></researchCard>

     <!-- 空白内容组件 -->
        <glEmpty
          v-if="mydata.articleListArr.length === 0"
           marginTop="20px"

        ></glEmpty>

    <!--分页 -->
    <div class="gl-pagination">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
  <script>
  // 是否来自其他模块
let fromOtherModule = false
// 缓存组件
import { defineComponent } from "vue"
export default defineComponent({
  name: 'parentChildGarden',
   beforeRouteEnter(to,from,next){    
    // 如果不是来自详情页面，而是来自其他模块，那么就把fromOtherModule设置为true值
   if (from.path !== '/layout/list/parentChildGardenDetails') {
      fromOtherModule = true
      // console.log('来自其他模块');      
    }
    next()
  }
});
</script>

<script setup>
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";
import { Star } from "@element-plus/icons-vue";
// import researchProjects from "@/components/researchProjects/index.vue";

// import bottomBar from "@/components/bottomBar/index.vue";

import textBar from "@/components/textBar/index.vue";

import researchCard from "@/components/researchCard/index.vue";

// import column from "@/components/column/index.vue";

// import colorCards from "@/components/colorCards/index.vue";

// import activityResultsCard from "@/components/activityResultsCard/index.vue";

// 引入接口
import { articleList } from "@/api/home/index.js";
// 引入接口
import { getUrlId } from "@/utils/slide.js";

import { reactive,onActivated } from "vue";

import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const mydata = reactive({
  path: "/layout/list/parentChildGardenDetails",
  articleListArr: [], // 文章列表

  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 4, // 每页条数
    total: 0, // 总的条数
  },
  form: {
    column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
  },
});


onActivated(()=>{
  // // 如果是来自其他模块，那么就重置数据
  // if (fromOtherModule) {
  // 如果是来自其他模块，那么就重置数据。或者，第一次进入这个页面，那么就重置数据
  if (fromOtherModule || JSON.parse(localStorage.getItem('routerRecord'))[route.path] === 1) {
  mydata.path= "/layout/list/parentChildGardenDetails";
  mydata.articleListArr= []; // 文章列表

  mydata.pageObj= {
    currentPage: 1, // 当前页数
    pageSize: 4, // 每页条数
    total: 0, // 总的条数
  };
  mydata.form= {
    column_id: getUrlId(route.path), // 栏目id值
    search: "", // 搜索查询
  };
  // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
  articleListFn()
  }
  // 重置fromOtherModule为false值，避免fromOtherModule一直是true值，不再动态变化
  fromOtherModule = false

  if (localStorage.getItem('v') !== null) {
    // 分页变成第一页
    mydata.pageObj.currentPage = 1
    mydata.form.search = localStorage.getItem('v') // 获取本地存储并且赋值
    localStorage.removeItem('v')  // 赋值后立刻删除本地存储内容
    
    // 把原来的函数调用放到缓存组件钩子里面了，原来的函数调用注释了
    articleListFn()
    
    // 拿到query参数并且赋值之后，就进行二次跳转，把query参数删除了，避免详情页面后退到列表页面的时候，再次拿到query参数并且赋值
    // router.push({
    //   path:"/layout/list/addedServices"
    // })
  }


})











// 当前页数改变事件
function handleCurrentChange(val) {
  // 查询
  articleListFn();
}

// 获取文章列表
function articleListFn() {
  articleList({
    ...mydata.form,
    page: String(mydata.pageObj.currentPage),
    psize: String(mydata.pageObj.pageSize),
  }).then((res) => {
    // 文章列表
    mydata.articleListArr = res.data.list;
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}

// 查询列表
function queryList(dict, inputValue) {
  // 分页变成第一页
  mydata.pageObj.currentPage = 1
  // 赋值
  mydata.form.search = inputValue;
  // 查询
  articleListFn();
}

// 查询
// articleListFn();
</script>
  
<style scoped lang="scss">
.research-b {
  // background-color: #f9f9f9;
  background-color: #ffffff;
  // padding-bottom: 40px;
  overflow: hidden;
  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 200px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 200px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 200px;
  //   // padding:30px;
  // }

  ///////输入框
  .box-input {
    width: 100%;
    // height: 100px;
    //   // border: 1px solid red;
    background-color: #ffffff;
    // border:1px solid red;
    padding: 10px 0px;
    border-bottom: 1px solid hsla(0, 0%, 80%, .8);
    // margin-bottom:16px;
    :deep(.inputBox) {
      margin: 0 auto;
      display: block;
      // border:1px solid red;
      .box2 {
        display: none;
      }
    }
  }

  ////////最顶部的title
  // .title-box {
  //   width: 1200px;
  //   margin: 0 auto;
  //   // border: 1px solid blue;
  //   margin-top: 40px;
  //   // margin-bottom: 20px;
  //   .title-left {
  //     height: 20px;
  //     // width:200px;
  //     // border:1px solid blue;
  //     display: flex;
  //     align-items: center;
  //     font-size: 14px;
  //     font-weight: 400;
  //     color: #bbbdbf;
  //     .line {
  //       margin: 0px 8px;
  //     }
  //     p:hover {
  //       color: #009de0;
  //     }
  //   }

  //   .title-right:hover {
  //     color: #009de0;
  //   }
  // }

  .big-box{
    margin-top:16px;
  }
}
</style>
